import apiFinancial from "../config/api_financial";
import getHeaders from "./getHeaders";

function findAllCostActivityTypeByGroupIdAndFarmId(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/costs/activity/types`,
    getHeaders(false, signal)
  );
}

export { findAllCostActivityTypeByGroupIdAndFarmId };
